import { create } from 'zustand'
import * as api from '@/lib/api'

interface FeaturesState {
  config: Record<string, any>
  fetchConfig: (profileId?: string) => Promise<void>
  getFeature: (key: string) => boolean
}

export const useFeatures = create<FeaturesState>()((set, get) => ({
  config: {},
  fetchConfig: async (profileId?: string) => {
    const config = await api.getFeatures(profileId)
    set({ config })
  },
  getFeature: (key: string) => {
    return !!get().config[key]
  },
}))
